import { render } from "./AnularSolicitudes.vue?vue&type=template&id=446fd3c2"
import script from "./AnularSolicitudes.vue?vue&type=script&lang=js"
export * from "./AnularSolicitudes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__